import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Shipment } from 'components/Shipment';

export const ShipmentPage: FC = () => {
	return (
		<Page title="Shipment – EAS Dashboard">
			<Shipment />
		</Page>
	);
};
